var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCode = function SvgIconCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8D8D8D",
    d: "M8 17.654 2.346 12 8 6.347l1.07 1.069-4.6 4.6L9.053 16.6zm8 0-1.07-1.07 4.6-4.6L14.947 7.4 16 6.347 21.654 12z"
  })));
};
export default SvgIconCode;